import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import CasualPlay from "../pages/play/CasualPlay";
import EventHome from "../pages/events/EventHome";
import EventOrganize from "../pages/events/EventOrganize";
import ArmyListSearchOld from "../pages/lists/ArmyListSearchOld";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import AccessDenied from "../pages/utility/AccessDenied";
import ArmyListSearch from "../pages/lists/ArmyListSearch";
import Account from "../pages/user/Account";
import Rankings from "../pages/rankings/Rankings";
import GameRouter from "../pages/pairings/GameRouter";
import NotFound from "../pages/utility/NotFound";
import { getEnvironmentVariable } from "../global/environmentVariables";
import SubscriptionNotice from "../pages/subscription/SubscriptionNotice";
import ArmyList from "../pages/lists/ArmyList";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";
const IS_DEMO = getEnvironmentVariable("IS_DEMO") === "true";
const REQUIRES_ORGANIZER =
  getEnvironmentVariable("REQUIRES_ORGANIZER") === "true";

export const appRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");

  return [
    {
      path: "app",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect appRoute />
        ) : (
          <MainLayout
            appRoute
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "event/:eventId",
          element: <EventHome appRoute />,
        },
        {
          path: "account",
          element: authContext?.authState?.isAuthenticated ? (
            <Account appRoute />
          ) : (
            <LoginRedirect appRoute />
          ),
        },
        {
          path: "list/:armyListId",
          element: authContext?.authState?.isAuthenticated ? (
            <ArmyList setEvent={setEventObject} />
          ) : (
            <LoginRedirect />
          ),
        },
        { path: "rankings", element: <Rankings appRoute /> },
        {
          path: "game/:pairingType/:objectId",
          element: (
            <GameRouter
              appRoute
              setEvent={setEventObject}
              setItemsMiddle={setItemsMiddle}
            />
          ),
        },
        { path: "game", element: <NotFound appRoute /> },
        {
          path: "subscription",
          element: !NO_SUBSCRIPTIONS ? <SubscriptionNotice /> : <NotFound />,
        },
      ],
    },
    {
      path: "app",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : REQUIRES_ORGANIZER &&
          authContext?.authState?.identity?.isAdmin !== true &&
          !authContext?.authState?.identity?.isOrganizer &&
          !authContext?.authState?.identity?.isJudge ? (
          <AccessDenied appRoute />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect appRoute />
        ) : (
          <MainLayout
            appRoute
            organize
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "organize/event",
          element: authContext?.authState?.isAuthenticated ? (
            REQUIRES_ORGANIZER &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.isOrganizer ? (
              <AccessDenied appRoute />
            ) : (
              <EventOrganize appRoute setItemsMiddle={setItemsMiddle} />
            )
          ) : (
            <LoginRedirect appRoute />
          ),
        },
        {
          path: "organize/event/:eventId",
          element: authContext?.authState?.isAuthenticated ? (
            <EventOrganize appRoute setItemsMiddle={setItemsMiddle} />
          ) : (
            <LoginRedirect appRoute />
          ),
        },
      ],
    },
    {
      path: "app",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect appRoute />
        ) : (
          <MainLayout
            appRoute
            play
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "play/my-games",
          element: authContext?.authState?.isAuthenticated ? (
            <CasualPlay appRoute />
          ) : (
            <LoginRedirect appRoute />
          ),
        },
        {
          path: "play/list-search-old",
          element:
            NO_SUBSCRIPTIONS ||
            authContext?.authState?.identity?.subscriber ||
            authContext?.authState?.identity?.isAdmin === true ? (
              <ArmyListSearchOld appRoute />
            ) : !authContext?.authState?.isAuthenticated ? (
              <LoginRedirect appRoute />
            ) : (
              <SubscriptionNotice />
            ),
        },
        {
          path: "play/list-search",
          element:
            NO_SUBSCRIPTIONS ||
            authContext?.authState?.identity?.subscriber ||
            authContext?.authState?.identity?.isAdmin === true ? (
              IS_DEMO  ? (
                <ArmyListSearch appRoute />
              ) : (
                <ArmyListSearchOld appRoute />
              )
            ) : !authContext?.authState?.isAuthenticated ? (
              <LoginRedirect appRoute />
            ) : (
              <SubscriptionNotice />
            ),
        },
      ],
    },
  ];
};
